program CATSCWeb;

uses
  Vcl.Forms,
  WEBLib.Forms,
  WebForm.Core in '..\..\SMXI-LIBS-2024\XData-Core\Web-Core\WebForm.Core.pas'{*.html},
  MainSitePage in 'MainSitePage.pas'{*.html},
  MainDataModule in 'MainDataModule.pas',
  Web.Core.Config in '..\..\SMXI-LIBS-2024\XData-Core\Web-Core\Web.Core.Config.pas',
  Web.Core.Consts in '..\..\SMXI-LIBS-2024\XData-Core\Web-Core\Web.Core.Consts.pas',
  SMX.Web.Utils in '..\..\SMXI-LIBS-2024\Web-Core-Utils\SMX.Web.Utils.pas',
  SMX.CRM.Utils in '..\..\SMXI-LIBS-2024\Web-Core-Utils\SMX.CRM.Utils.pas',
  SMX.Web.Document.Utils in '..\..\SMXI-LIBS-2024\Web-Core-Utils\SMX.Web.Document.Utils.pas',
  SMX.Web.Table.Simple in '..\..\SMXI-LIBS-2024\Web-Core-Utils\SMX.Web.Table.Simple.pas',
  MainForm.Base in '..\..\SMXI-LIBS-2024\XData-Core\Web-Core\MainForm.Base.pas'{*.html},
  smx.webcore.types in '..\..\SMXI-LIBS-2024\XData-Core\Web-Core\smx.webcore.types.pas',
  SMX.Auth.Shared in '..\..\SMXI-LIBS-2024\XData-Core\Auth\SMX.Auth.Shared.pas',
  Dataset.Plugins in '..\..\SMXI-LIBS-2024\XData-Core\Web-Core\Dataset.Plugins.pas',
  Grid.Plugins in '..\..\SMXI-LIBS-2024\XData-Core\Web-Core\Grid.Plugins.pas',
  Grid.Settings in '..\..\SMXI-LIBS-2024\XData-Core\Web-Core\Grid.Settings.pas',
  Paginator.Plugins in '..\..\SMXI-LIBS-2024\XData-Core\Web-Core\Paginator.Plugins.pas',
  ErrorPage in 'ErrorPage.pas'{*.html},
  SMX.XDataSvc.Utils in '..\..\SMXI-LIBS-2024\Web-Core-Utils\SMX.XDataSvc.Utils.pas',
  App.Web.Utils in 'App.Web.Utils.pas',
  SMX.Web.Layout.Utils in '..\..\SMXI-LIBS-2024\Web-Core-Utils\SMX.Web.Layout.Utils.pas',
  App.Enumerations in '..\Server\Entities\App.Enumerations.pas',
  App.ReturnTypes in '..\Shared\App.ReturnTypes.pas',
  App.Web.Consts in 'App.Web.Consts.pas',
  App.Shared in '..\Shared\App.Shared.pas',
  DashboardPage in 'DashboardPage.pas'{*.html},
  SchoolListPage in 'SchoolListPage.pas'{*.html},
  AcademyListPage in 'AcademyListPage.pas'{*.html},
  SchoolEditPage in 'SchoolEditPage.pas'{*.html},
  AcademyEditPage in 'AcademyEditPage.pas'{*.html},
  SchoolAccountEditPage in 'SchoolAccountEditPage.pas'{*.html},
  EditBaseForm in '..\..\SMXI-LIBS-2024\XData-Core\Web-Core\EditBaseForm.pas'{*.html},
  BaseList in '..\..\SMXI-LIBS-2024\XData-Core\Web-Core\BaseList.pas'{*.html},
  BaseSitePage in '..\..\SMXI-LIBS-2024\XData-Core\Web-Core\BaseSitePage.pas'{*.html},
  CRM.Enumerations in '..\..\SMXI-LIBS-2024\XData-Core\Models\CRM\CRM.Enumerations.pas',
  CostingListPage in 'CostingListPage.pas'{*.html},
  CostingEditPage in 'CostingEditPage.pas'{*.html},
  DashboardMethods in 'DashboardMethods.pas',
  XData.Dataset.Utils in '..\..\SMXI-LIBS-2024\XData-Core\Web-Core\XData.Dataset.Utils.pas',
  InvoiceListPage in 'InvoiceListPage.pas'{*.html},
  InvoiceEditPage in 'InvoiceEditPage.pas'{*.html},
  ActionsPage in 'ActionsPage.pas'{*.html},
  App.Server.Responses in '..\Server\Entities\App.Server.Responses.pas',
  EventViewerListPage in 'EventViewerListPage.pas'{*.html},
  EventViewerEditPage in 'EventViewerEditPage.pas'{*.html},
  RemittancesListPage in 'RemittancesListPage.pas'{*.html},
  RemittancesEditPage in 'RemittancesEditPage.pas'{*.html},
  InvoiceRemittanceViewerPage in 'InvoiceRemittanceViewerPage.pas'{*.html},
  App.Version in 'App.Version.pas',
  Web.StringUtils in 'Web.StringUtils.pas',
  CommunicationsListPage in 'CommunicationsListPage.pas'{*.html},
  BaseListNoGrid in '..\..\SMXI-LIBS-2024\XData-Core\Web-Core\BaseListNoGrid.pas',
  Auth.Service in '..\..\SMXI-LIBS-2024\XData-Core\Web-Core\Auth.Service.pas';

{$R *.res}

begin
  Application.Initialize;
  Application.MainFormOnTaskbar := True;
  Application.CreateFormDirect(TMainData, MainData);
  Application.Run;
end.
